import { render, staticRenderFns } from "./ScoreItem.vue?vue&type=template&id=38b7cad0&scoped=true&lang=pug&"
import script from "./ScoreItem.vue?vue&type=script&lang=js&"
export * from "./ScoreItem.vue?vue&type=script&lang=js&"
import style0 from "./ScoreItem.vue?vue&type=style&index=0&id=38b7cad0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b7cad0",
  null
  
)

component.options.__file = "ScoreItem.vue"
export default component.exports